<template>
  <v-container>
    <div class="page">
      <div class="section-title">{{web.head}}</div>
      <p class="section-description">{{web.description}}</p>
      <div v-for="(item, index) in web.items" :key="index">
        <div class="section-second-title">{{ item.title }}</div>
        <div v-if="item.hasSubItems">
          <v-divider class="line"></v-divider>
          <div v-for="(sub, index) in item.subItems" :key="index">
            <div class="item-context">
              <div class="item-col-1">
                {{sub.title}}: {{sub.description}}
              </div>
              <v-btn
                :disabled="!(sub.flag || sub.downloadEnabled)"
                variant="tonal"
                color="info"
                class="mr-2"
                size="x-small"
                @click="download_web(sub.downloadWebName)">
                Download
              </v-btn>
            </div>
            <v-divider class="line"></v-divider>
          </div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import { getDownloadUrl } from '@/config'

export default {

  data() {
    return {
      web: {
        head: 'Web',
        description: 'Users can download the instructions using the following links of the function modules',
        items: [{
          title: 'E-BIO',
          hasSubItems: true,
          subItems: [{
            title: 'EBio',
            description: 'explore the biological explanation',
            downloadWebName: 'ebio_web.zip',
            flag: true
          }]
        },{
          title: 'E-DB',
          hasSubItems: true,
          subItems: [{
            title: 'EDb',
            description: 'database for supporting the ExposomeX platform',
            downloadWebName: 'edb_web.zip',
            flag: true
          }]
        },{
          title: 'E-VIZ',
          hasSubItems: true,
          subItems: [{
            title: 'EViz',
            description: 'visualize the data',
            downloadWebName: 'eviz_web.zip',
            downloadEnabled: true,
          }]
        },{
          title: 'E-META',
          hasSubItems: true,
          subItems: [{
            title: 'EMeta',
            description: 'provide the summary of previous publications',
            downloadWebName: 'EMeta',
          }]
        },{
          title: 'E-MS',
          hasSubItems: true,
          subItems: [{
            title: 'EMS',
            description: 'analyze the non-targeted analysis data from HRMS',
            downloadWebName: 'EMS',
          }]
        },{
          title: 'E-STAT',
          hasSubItems: true,
          subItems: [{
            title: 'StatTidy',
            description: 'tidying data',
            downloadWebName: 'StatTidy',
          },{
            title: 'StatDesc',
            description: 'describe the data',
            downloadWebName: 'StatDesc',
          },{
            title: 'StatCros',
            description: 'analyze the cross-sectional data',
            downloadWebName: 'StatCros',
          },{
            title: 'StatMO',
            description: 'analyze the data of multi-omics',
            downloadWebName: 'StatMO',
          },{
            title: 'StatPanel',
            description: 'analyze the data of panel study',
            downloadWebName: 'StatPanel',
          },{
            title: 'StatSurv',
            description: 'analyze the censored data',
            downloadWebName: 'StatSurv',
          },{
            title: 'StatMedt',
            description: 'screen the mediation pathway',
            downloadWebName: 'StatMedt',
          },{
            title: 'StatMix',
            description: 'analyze the effect of mixture exposure',
            downloadWebName: 'StatMix',
          },{
            title: 'StatHEP',
            description: 'predict human chemical exposure',
            downloadWebName: 'StatHEP',
          },{
            title: 'StatIP',
            description: 'explore the statistical explanation',
            downloadWebName: 'StatIP',
          }]
        }]
      },
    };
  },
  methods: {
    async download_web(name) {
      let a = document.createElement('a')
      a.href = getDownloadUrl('web', name)
      a.target = '_blank'
      a.click()
    }
  }
};
</script>

<style scoped lang="scss">
.page {
  font-size: $webpage-base-font-size;
  margin-left: 2em;
}
p {
  text-indent: 0;
}
.section-title {
  font-size: $webpage-large-font-size;
  font-weight: bold;
  line-height: 1.4;
}
.section-second-title {
  font-weight: bold;
  margin: 0.6em 0 0.2em;
}
.section-description {
  margin-bottom: 0.8em;
}
.item-context {
  display: flex;
  gap: 60px;
  align-items: center;
  line-height: 1.6;
  margin: 0.2em 0;
  justify-content: start;
}
.item-col-1 {
  min-width: 800px;
}
.line {
  width: 90%;
}
@media screen and (min-width: 601px) and (max-width: 1280px) {
  .line {
    width: 100%;
  }
  .item-col-1 {
    min-width: 0;
  }
  .item-context {
    justify-content: space-between;
  }
}
@media screen and (max-width: 600px) {
  .page {
    margin: 0;
  }
  .line {
    width: 100%;
  }
  .item-context {
    display: flex;
    gap: 5px;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .item-col-1 {
    min-width: 0;
  }
}

</style>
